//import axios from 'axios';
import Cookies from 'js-cookie'; 
import clienteHttp from './ClienteHttps';

//const API_BASE_URL = process.env.REACT_APP_API_URL ||'http://localhost:3001';
const USUARIO_KEY = 'sweetmedical_usuario';

//enviar cookies en cada request
//axios.defaults.withCredentials = true;

class AuthService {

    constructor() {
        // Ya no necesitamos token en memoria porque esta en la cookie HttpOnly
        // El usuario lo guardamos en una cookie normal o el localStora
    }


    async login(email, password) {
        try {
            const response = await clienteHttp.post(`/auth/login`, {
                email,
                password
            });

            const { usuario } = response.data;

            //guardo el usuario en una cookie
            Cookies.set(USUARIO_KEY, JSON.stringify(usuario), { expires: 1 });

            return { usuario };
        } catch (error) {
            const mensaje = error.response?.data?.mensaje || 'Error al iniciar sesión';
            throw new Error(mensaje);
        }
    }

    //Ya no necesitariamos setAuthHeader porque el token se envia en la cookie
    
    async registrar(datos) {
        try {
            const response = await clienteHttp.post(`/auth/registrar`, datos);
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.mensaje || 'Error al registrar usuario';
            throw new Error(mensaje);
        }
    }


    logout() {
        // Llamar al backend para eliminar la cookie HttpOnly
        clienteHttp.post(`/auth/logout`).catch(() => {
            // Si falla, igual limpiamos el frontend
        });
        
        // Eliminar el usuario guardado
        Cookies.remove(USUARIO_KEY);
        
        // Redirigir al login
        window.location.href = '/login';
    }


    getUsuarioActual() {
        const usuarioStr = Cookies.get(USUARIO_KEY); //leo el usuario de la cookie
        if (!usuarioStr) return null;
        try {
            return JSON.parse(usuarioStr);
        } catch {
            return null;
        }
    }

    isAuthenticated() {
        return !!this.getUsuarioActual();
    }

/*
    async obtenerPerfil() {
        try {
            const response = await axios.get(`${API_BASE_URL}/auth/perfil`);
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.mensaje || 'Error al obtener perfil';
            throw new Error(mensaje);
        }
    }
*/

    async obtenerPerfil() {
    try {
        const response = await clienteHttp.get(`/auth/perfil`);
        // Asegurar que el objeto tenga un campo 'id' consistente
        const perfil = response.data;
        if (perfil && perfil._id && !perfil.id) {
        perfil.id = perfil._id; // Normalizar
        }
        return perfil;
    } catch (error) {
        const mensaje = error.response?.data?.mensaje || 'Error al obtener perfil';
        throw new Error(mensaje);
    }
    }


    async cambiarPassword(passwordActual, nuevaPassword) {
        try {
            const response = await clienteHttp.put(`/auth/cambiar-password`, {
                passwordActual,
                nuevaPassword
            });
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.mensaje || 'Error al cambiar contraseña';
            throw new Error(mensaje);
        }
    }
}

export default new AuthService();